import RelocationsPage from './RelocationsPage.vue';
import RelocationsTable from './RelocationsTable.vue';
import RelocationsMapPage from './RelocationsMapPage.vue';

export * from './types';
export {
    RelocationsPage as default,
    RelocationsPage,
    RelocationsTable,
    RelocationsMapPage,
};
